import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import { getTasks } from '../../redux/selectors';
import TasksList from '../../components/tasks-list';
import { openModal, modalNames } from '../../modals';
import { sortTasksByDueDate, checkRequestForNextAction } from '../../utils';
import { handleTaskDelete, handleTaskOptimisticUpdate } from '../../redux/thunk/tasks';


const mapStateToProps = (state, props) => R.compose(
  ({ tasks }) => ({ tasks: sortTasksByDueDate(tasks) }),
  data => ({ tasks: getTasks(data, props) }),
)(state);

export default compose(
  connect(
    mapStateToProps,
    { openModal, handleTaskOptimisticUpdate, handleTaskDelete },
  ),
  withHandlers({
    handleTaskDelete: props => (taskId) => {
      props.handleTaskDelete(taskId, props.tasks.length, props.meetingNote)
        .then(task => checkRequestForNextAction(task, props.openModal));
    },
    openTaskModal: actions => (taskId, requestId) =>
      actions.openModal({
        name: modalNames.TASKS,
        payload: {
          taskId, requestId, type: 'view',
        },
      }),
    handleTaskUpdate: actions => (taskId, requestId) => {
      actions.openModal({
        name: modalNames.TASKS,
        payload: { taskId, requestId },
      });
    },
    handleTaskStatusUpdate: props => (taskId, value) => {
      props.handleTaskOptimisticUpdate(taskId, { status: value })
        .then(task => checkRequestForNextAction(task, props.openModal));
    },
    handleTaskPriorityUpdate: props => (taskId, value) => {
      props.handleTaskOptimisticUpdate(taskId, { taskPriority: value });
    },
    onTaskCreate: actions => (requestId) => {
      actions.openModal({
        name: modalNames.TASKS,
        payload: { requestId },
      });
    },
  }),
)(TasksList);



// WEBPACK FOOTER //
// ./src/containers/tasks-simple-list/index.js